import Styled from 'styled-components';

const HeaderContainer = Styled.div`
`;

const DataWrapper = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
`;

const DistributionWrapper = Styled.div`
  width: 100%;

  > div {
    width: 100%;

    > div {
      width: 100%;

      > div {
        &:nth-child(2) {
          width: 100%;
        }
      }

      > span {
        min-width: 45px;
      }
    }
  }
`;

const SelectsWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin: 15px 0;
`;

const FilterTagWrapper = Styled.div`
  display: flex;
  padding:12px 0 ;
  align-items: center;
  
`;
export default HeaderContainer;
export { HeaderContainer, DataWrapper, SelectsWrapper, DistributionWrapper, FilterTagWrapper };
